import { render } from "./FormaPagamentoModal.vue?vue&type=template&id=d841832c&ts=true"
import script from "./FormaPagamentoModal.vue?vue&type=script&lang=ts"
export * from "./FormaPagamentoModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__